module.exports = __webpack_public_path__ + "img/icon-device.95161174.svg";